import { Paper, Typography, CircularProgress } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
`;

export const WrapperTitle = styled(Typography)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 2rem;

  p {
    text-transform: uppercase;

    font-weight: 700;
    font-size: 1.2rem;
  }
`;

export const WrapperTabela = styled(Paper)`
  padding: 1rem;

  width: 100%;

  display: flex;
  flex-direction: column;

  position: relative;

  .MuiTableContainer-root {
    max-height: ${(props) => props.height};

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }
  }

  tr {
    cursor: pointer;
  }
`;

export const WrapperLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  background: rgba(255, 255, 255, 0.6);

  width: 100%;
  height: 100%;

  z-index: 3;

  display: flex;
  align-items: center;
  justify-content: center;
`;
